import { render, staticRenderFns } from "./CloseTeachTableDialog.vue?vue&type=template&id=2c39a7fc"
import script from "./CloseTeachTableDialog.vue?vue&type=script&lang=js"
export * from "./CloseTeachTableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports